'use strict';

define('vb/private/types/utils/serviceDataProviderRestHelperFactory',[
  'vb/private/helpers/restHelperFactory',
  'vb/private/types/utils/serviceDataProviderRestHelper',
], (RestHelperFactory, ServiceDataProviderRestHelper) => {
  /**
   * @typedef {import('vb/private/services/endpointReference').OperationRef} OperationRef
   * @typedef {import('vb/private/services/serviceResolverFactory').ServiceContext} ServiceContext
   */

  class ServiceDataProviderRestHelperFactory extends RestHelperFactory {
    /**
     * This is (currently) a PRIVATE factory for internal use
     *
     * Creates ServiceDataProviderRestHelper instance.
     * @param {string|OperationRef} [endpointReference]
     * @param {ServiceContext} [serviceContext]
     *
     * @returns {ServiceDataProviderRestHelper}
     */
    static get(endpointReference, serviceContext) {
      return /** @type {ServiceDataProviderRestHelper} */ (
        // eslint-disable-next-line no-underscore-dangle
        RestHelperFactory._createRestHelper(ServiceDataProviderRestHelper, endpointReference, serviceContext)
      );
    }
  }
  return ServiceDataProviderRestHelperFactory;
});

